import { Grid } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import BadgeButton from "components/BadgeButton";
import { DefaultInfo } from "components/NothingRight";
import { PAPS_OBS_PLACE_ID } from "config/constants";
import { COLORS } from "constants/colors";
import useText from "constants/text";
import { Client, SubTask, SubTaskStatus, SubTaskType } from "generated/graphql";
import moment from "moment";
import React from "react";
import { ContainerBadge, ContainerTaskDetails } from "../Styles";
import SubTaskPath from "../tasks/SubTaskPath";
import { GoogleMap } from "./GoogleMap";

const useStyles = makeStyles(() =>
  createStyles({
    mapStyle: {
      position: "relative",
    },
    details: {
      borderRadius: 17,
      position: "absolute",
      height: 126,
      width: "29%",
      flexGrow: 0,
      marginTop: 21,
      backgroundColor: COLORS.white,
          marginLeft: "10px"

    },
  })
);

const ToReschudules = [SubTaskStatus.Assigned, SubTaskStatus.Unassigned];
export interface PropsRightTaskDisplay {
  task?: SubTask;
  client?: Client;
  openParcelsHandler?: (task: SubTask) => void;
  openUpdateHandler?: (task: SubTask) => void;
}
export function TaskDisplay({ task, client, openParcelsHandler, openUpdateHandler }: PropsRightTaskDisplay) {
  const styles = useStyles();
  const [isValid, setValid] = React.useState<boolean>(false);
  const { text } = useText();
  React.useEffect(() => {
    if (task) {
      const date = moment(task?.subtask_execution_date).add(
        Number(task?.subtask_execution_slot_start.split(":")[0]) - 1,
        "h"
      );
      setValid(
        date.isAfter(new Date()) &&
          ToReschudules.includes(task?.subtask_status) &&
          task?.subtask_type === SubTaskType.Pickup
      );
    }
  }, [task]);
  return (
    <>
      {task ? (
        <Grid container spacing={1}>
          <Grid className={styles.mapStyle}>
            <GoogleMap
              id="map"
              options={{
                center: { lat: 14.739068, lng: -17.472984 },
                zoom: 16,
                disableDefaultUI: true,
              }}
              destination={
                task?.subtask_type === SubTaskType.Delivery ? PAPS_OBS_PLACE_ID : task?.subtask_address?.place_id
              }
              orgin={task?.subtask_type === SubTaskType.Pickup ? PAPS_OBS_PLACE_ID : task?.subtask_address?.place_id}
              travelMode= "DRIVING"
              
            />
          </Grid>
          <Grid className={styles.details}>
            <ContainerTaskDetails>
              <SubTaskPath subTask={task} client={client} />
              <ContainerBadge>
                <BadgeButton
                  value={`${task.subtask_operation_on_parcel.length} `}
                  onClick={openParcelsHandler}
                  element={task}
                  withoutBadgeStyle
                />
              </ContainerBadge>
            </ContainerTaskDetails>
          </Grid>
        </Grid>
      ) : (
        <DefaultInfo />
      )}
    </>
  );
}

export default TaskDisplay;
